import PropTypes from 'prop-types';

const TIER_CONFIG = {
  bronze: {
    name: 'Bronze', icon: '🥉', color: '#cd7f32', bg: 'bg-amber-900/20', text: 'text-amber-700 dark:text-amber-400',
  },
  silver: {
    name: 'Silver', icon: '🥈', color: '#c0c0c0', bg: 'bg-gray-200/40', text: 'text-gray-600 dark:text-gray-300',
  },
  gold: {
    name: 'Gold', icon: '🥇', color: '#ffd700', bg: 'bg-yellow-100/40', text: 'text-yellow-700 dark:text-yellow-400',
  },
  platinum: {
    name: 'Platinum', icon: '💎', color: '#e5e4e2', bg: 'bg-purple-100/40', text: 'text-purple-700 dark:text-purple-300',
  },
  diamond: {
    name: 'Diamond', icon: '👑', color: '#b9f2ff', bg: 'bg-cyan-100/40', text: 'text-cyan-700 dark:text-cyan-300',
  },
};

function LeagueBadge({ tier, size, showLabel }) {
  const config = TIER_CONFIG[tier];
  if (!config) return null;

  const sizeClasses = {
    sm: 'text-sm px-1.5 py-0.5 gap-1',
    md: 'text-base px-2 py-1 gap-1.5',
    lg: 'text-2xl px-3 py-2 gap-2',
  };

  const iconSizes = {
    sm: 'text-sm',
    md: 'text-lg',
    lg: 'text-3xl',
  };

  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold ${config.bg} ${config.text} ${sizeClasses[size]}`}
    >
      <span className={iconSizes[size]}>{config.icon}</span>
      {showLabel && <span>{config.name}</span>}
    </span>
  );
}

LeagueBadge.propTypes = {
  tier: PropTypes.oneOf(['bronze', 'silver', 'gold', 'platinum', 'diamond']).isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  showLabel: PropTypes.bool,
};

LeagueBadge.defaultProps = {
  size: 'sm',
  showLabel: true,
};

export { TIER_CONFIG };
export default LeagueBadge;
